import { useConfigContext } from '@customink/project-service-react-components';

import { pageViewTag } from '@/utils/metrics';

export const useEditDesignLink = (designCid?: string) => {
  const { labProxyUrl } = useConfigContext();
  const handleEditDesign = (params?: Record<string, string>) => {
    if (!designCid) return;
    const searchParams = new URLSearchParams({
      cart: 'true',
      cid: designCid,
      load_method: 'editfromcart',
      ...params,
    });
    window.location.href = `${labProxyUrl}?${searchParams.toString()}`;
  };
  return handleEditDesign;
};
